<div class="rounded-md drop-shadow-md p-1 {{ type }} bg-white flex justify-between items-center gap-2">
  <div class="flex flex-row items-center w-full gap-2" [ngClass]="{ 'justify-center' : showIcon }">
    @if (showIcon) {
      @if (type === 'announcement') {
        <app-sms-spinner size="sm"></app-sms-spinner>
      }
      @if (type === 'alert') {
        <mat-icon>warning</mat-icon>
      }
      @if (type === 'success') {
        <mat-icon>check_circle</mat-icon>
      }
    }

    <div [ngClass]="{ 'mx-auto': !showIcon }">
      <ng-content></ng-content>
    </div>
  </div>

  @if (canDismiss) {
    <span class="float-right">
      <button mat-icon-button class="leading-none" (click)="closeNotice()"><mat-icon class="text-white">close</mat-icon></button>
    </span>
  }

</div>
